import React from "react";

// Phase 3M — extracted verbatim from RetailCustomer.jsx::CategoryTabs.
// Scroll-spy ownership stays in the parent (KioskShell); this component
// only renders the pill row and emits an `onJump(name)` callback.
export default function CategoryTabs({ categories, active, onJump }) {
  return (
    <nav className="bg-[#e8efd0] border-b border-emerald-900/20 px-3 sm:px-4 py-2 overflow-x-auto scrollbar-none shrink-0" data-testid="retail-category-tabs">
      <div className="flex items-center gap-2 min-w-max">
        {categories.map((c) => {
          const isActive = c.name === active;
          return (
            <button
              key={c.name}
              type="button"
              onClick={() => onJump(c.name)}
              data-testid={`retail-cat-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
              className={
                "shrink-0 px-3 py-1.5 rounded-md text-sm font-medium transition " +
                (isActive
                  ? "bg-orange-500 text-white"
                  : "bg-transparent text-emerald-900 hover:bg-emerald-900/10")
              }
            >
              {c.name}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
